export class Difficulty {
    idGameMode: number;
    idDifficulty: number;
    name: string;

    constructor(name: string, idGameMode: number, idDifficulty: number) {
        this.name = name;
        this.idGameMode = idGameMode;
        this.idDifficulty = idDifficulty;
    }
}